import React, { useCallback } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

const DeleteableEdge: React.FC<any> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  onDelete,
  reactFlow,
  ...props
}) => {
  const { getSmoothStepPath, EdgeLabelRenderer, BaseEdge } = reactFlow;

  // Use getSmoothStepPath with custom borderRadius for curved edges
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 20, // Add border radius for curved corners
  });

  const handleDelete = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      if (onDelete) {
        onDelete(id);
      }
    },
    [id, onDelete]
  );

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          strokeWidth: 2,
          stroke: "#374151",
        }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            pointerEvents: "all",
            zIndex: 1000, // Ensure it's on top
          }}
          className="nodrag nopan"
        >
          <Tooltip title="Delete Connection" placement="top">
            <IconButton
              size="small"
              color="error"
              onClick={handleDelete}
              sx={{
                width: 24,
                height: 24,
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                border: "2px solid #e5e7eb",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  backgroundColor: "rgba(239, 68, 68, 0.1)",
                  borderColor: "#ef4444",
                  transform: "scale(1.1)",
                },
                "& .MuiSvgIcon-root": {
                  fontSize: "14px",
                },
                transition: "all 0.2s ease-in-out",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default DeleteableEdge;
